import React from 'react';
import ModalBody from '../modal/ModalBody';
import ModalFooter from '../modal/ModalFooter';
import ModalHeader from '../modal/ModalHeader';

type CheckinConfirmModalProps = {
  show: boolean;
  sessionType: 'remote_sick' | 'sick' | 'business_trip' | null;
  onConfirm: () => void;
  onCancel: () => void;
};

const CheckinConfirmModal: React.FC<CheckinConfirmModalProps> = ({ show, sessionType, onConfirm, onCancel }) => {
  if (!show) {
    return null;
  }

  const getModalContent = () => {
    if (sessionType === 'remote_sick') {
      return {
        title: 'Check In as Remote Sick',
        body: (
          <>
            <p>You are about to check in as <strong>remote sick</strong>.</p>
            <p>This means you are working from home while sick. Your work session will be tracked accordingly.</p>
            <p>Are you sure you want to proceed?</p>
          </>
        ),
        confirmButton: 'Confirm Remote Sick Check-in'
      };
    } else if (sessionType === 'sick') {
      return {
        title: 'Sick Leave',
        body: (
          <>
            <p>You are about to mark today as <strong>sick leave</strong>.</p>
            <p>This means you are not working at all today. No work session will be tracked.</p>
            <p>Are you sure you want to proceed?</p>
          </>
        ),
        confirmButton: 'Confirm Sick Leave'
      };
    } else if (sessionType === 'business_trip') {
      return {
        title: 'Check In as Business Trip',
        body: (
          <>
            <p>You are about to check in as <strong>business trip</strong>.</p>
            <p>This means you are traveling for work. Your work session will be tracked accordingly.</p>
            <p>Are you sure you want to proceed?</p>
          </>
        ),
        confirmButton: 'Confirm Business Trip Check-in'
      };
    }

    return { title: '', body: null, confirmButton: '' };
  };

  const content = getModalContent();

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <ModalHeader onCloseClick={onCancel} title={content.title} />
          <ModalBody>
            {content.body}
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary primary-color"
              onClick={onConfirm}
            >
              {content.confirmButton}
            </button>
          </ModalFooter>
        </div>
      </div>
    </div>
  );
};

export default CheckinConfirmModal;
